export enum TourProvider {
  THY = 'Thy',
  PEGASUS = 'Pegasus',
  ATLAS = 'Atlas',
  CONTENT_INN = 'ContentInn',
  AMADEUS = 'Amadeus',
  EXPEDIA = 'Expedia',
  SETUR_LOCAL_HOTEL = 'SeturLocalHotel',
  AKGUNLER = 'Akgunler',
  SETUR_LOCAL_TOUR = 'SeturLocalTour',
}
